import React, { FC, useContext } from "react"
import { HR, Spacer } from "../../atoms/Atoms"
import L10n from "../../../../lib/carrot-l10n"
import { Body } from "components/views/atoms/Bodies"
import { ButtonPrimary } from "../../atoms/buttons/ButtonPrimary"
import { SendMessageFormContext } from "../../../containers/talktocarrot/SendMessageFormContainer"
import { FlexContainer, H2, H4 } from "@carrotfertility/carotene"
import { BenefitEnrollmentModalContinueButton } from "../../../csd-enrollment/shared"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

interface ThankYouProps {
  showHeader?: boolean
  showBottomLine?: boolean
  close?: boolean
  onClick?: () => void
  continueLink?: boolean
}

const ThankYou: FC<ThankYouProps> = ({ close = false, showHeader = true, showBottomLine = true, onClick = null, continueLink = false }) => {
  const { personalEmail, employeeEmail, partnerEmail, sentFromPartnerEmail } = useContext(SendMessageFormContext)

  return (
    <>
      {showHeader && <H4>{l`Send a message`}</H4>}
      <Spacer height={1.5} />
      <H2>{l`Received!`}</H2>
      <Spacer height={0.5} />
      <Body color="black-80">
        {l`We’ll get back to you at `}
        <b>{sentFromPartnerEmail ? partnerEmail : personalEmail ?? employeeEmail}</b>
        {l`, your `}
        {sentFromPartnerEmail ? l`partner's` : personalEmail ? l`preferred` : l`account`}
        {l` email.`}
      </Body>
      <Spacer height={3.5} />
      {continueLink ?
        <BenefitEnrollmentModalContinueButton onClick={onClick} /> :
        <FlexContainer justifyContent={close ? "center" : "flex-end"}>
          <ButtonPrimary onClick={onClick} to="/">{close ? l`Close` : l`done`}</ButtonPrimary>
        </FlexContainer>
      }

      {showBottomLine && (
        <>
          <Spacer height={1.5} />
          <HR color="black-10" />
          <Spacer height={1.5} />
        </>
      )}
    </>
  )
}

export { ThankYou }
